$pds-divider-offsets: (
  xxs: var(--pine-dimension-2xs),
  xs: var(--pine-dimension-xs),
  sm: var(--pine-dimension-sm),
  md: var(--pine-dimension-md),
  lg: var(--pine-dimension-lg),
  xl: var(--pine-dimension-xl),
  xxl: var(--pine-dimension-2xl),
);

.pds-divider {
  background: var(--pine-color-border);
  border: 0;
  display: flex;
  height: var(--pine-border-width);
  margin: 0;
  width: 100%;
}

.pds-divider--vertical {
  height: 100%;
  width: 1px;
}

@each $offset, $value in $pds-divider-offsets {
  .pds-divider--offset-#{$offset} {
    margin: 0 calc($value * -1);
    padding: 0 $value;

    &.pds-divider--vertical {
      margin: calc($value * -1) 0;
      padding: $value 0;
    }
  }
}

@media (max-width: 767px) {
  .pds-divider--vertical {
    display: none;
  }
}
